import { CampaignAdGroupProductCategory } from '../types/Campaign';

const DspProductCategoryUtils = {
    toDspProductCategoryIds: (targets: CampaignAdGroupProductCategory[]) => {
        return targets?.map((target: CampaignAdGroupProductCategory) => target.dspCategoryId) || [];
    },
};

export default DspProductCategoryUtils;
